export default {
  'seo:default-description':
    "Premium diervoeding van Pets Deli | BARF-menu's, natvoer, droogvoer & snacks voor honden en katten ✓ 100% diervriendelijk ✓ levensmiddelenkwaliteit ✓ → ontdek het nu!",
};
